export default {
  state: {
    dataIdle: {},
    dataIdleExam: {},
    dataSearchIdleExam: {},
    dataExam: {},
    dataConsult: {},
  },

  getters: {
    getIdleData(state) {
      return state.dataIdle;
    },
    getIdleExamData(state) {
      return state.dataIdleExam;
    },

    getSearchIdleExam(state) {
      return state.dataSearchIdleExam;
    },

    getExamData(state) {
      return state.dataExam;
    },
    getConsultData(state) {
      return state.dataConsult;
    },
  },

  mutations: {
    setIdleData(state, data) {
      const isNull = data === null;

      state.dataIdle = {
        id: !isNull ? data.id : "",
        grid_code: !isNull ? data.grid_code : "",
        schedule_code: !isNull ? data.schedule_code : "",
        schedule_date: !isNull ? data.schedule_date : "",
        schedule_status: !isNull ? data.schedule_status : "",
        procedure: !isNull ? data.procedure : "",
        procedure_code: !isNull ? data.procedure_code : "",
        name_professional: !isNull ? data.name_professional : "",
        cpf_professional: !isNull ? data.cpf_professional : "",
        speciality: !isNull ? data.speciality : "",
        speciality_code: !isNull ? data.speciality_code : "",
      };
    },
    setIdleExamData(state, data) {
      state.dataIdleExam = data;
    },
    setSearchIdleExam(state, data) {
      state.dataSearchIdleExam = data;
    },
    setExamData(state, data) {
      state.dataExam = data;
    },
    setConsultData(state, data) {
      state.dataConsult = data
    },
  },

  actions: {
    changeIdleData(context, infos) {
      context.commit("setIdleData", infos);
    },
    changeIdleExamData(context, infos) {
      context.commit("setIdleExamData", infos);
    },
    changeSearchIdleExam(context, infos) {
      context.commit("setSearchIdleExam", infos);
    },
    changeExamData(context, infos) {
      context.commit("setExamData", infos);
    },
    changeConsultData(context, infos) {
      context.commit("setConsultData", infos);
    },
  },
};
